import MUITab from "@mui/material/Tab";
import classNames from "classnames";
import "./Tab.scss";

export interface ITabProps {
  index: number;
  label: React.ReactNode;
  onClick: (index: number) => void;
  className?: string;
  selected?: boolean;
  small?: boolean;
  withIndicator?: boolean;
  icon?: JSX.Element;
}

export const Tab = ({
  index,
  label,
  onClick,
  className,
  selected = false,
  small = false,
  withIndicator,
  icon,
  ...rest
}: ITabProps) => {
  const classes = classNames("Tab", className, {
    "Tab--selected": selected,
    "Tab--small": small,
    "Tab--withIndicator": withIndicator,
  });

  return (
    <>
      <MUITab
        label={label}
        disableRipple
        className={classes}
        id={`tab-${index}`}
        aria-controls={`tabpanel-${index}`}
        onClick={() => onClick(index)}
        value={index}
        icon={icon}
        {...rest}
      />
    </>
  );
};
